import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {
  id: number;
};
type Response = Car;

export const useCar = createQuery<Response, Variables, AxiosError>({
  queryKey: ['partner/car'],
  fetcher: ({ id }) => {
    return client.get(`v2/internal/partners/cars/${id}`).then((response) => {
      return response.data.data;
    });
  },
});
